import { Box, Typography } from '@mui/material'
import { CarrierListItem } from 'pages/address/address.hooks'

interface AddressCarrierListItemProps {
  item: CarrierListItem
  isSelected: boolean
  onSelect: () => void
}

const AddressCarrierListItem = ({
  item,
  isSelected,
  onSelect,
}: AddressCarrierListItemProps) => {
  return (
    <Box
      onClick={onSelect}
      sx={{
        px: 2,
        py: 1.5,
        cursor: 'pointer',
        bgcolor: isSelected ? 'primary.main' : 'common.white',
        color: isSelected ? 'common.white' : 'text.primary',
        borderBottom: '1px solid',
        borderColor: 'divider',
        '&:hover': {
          bgcolor: isSelected ? 'primary.main' : 'grey.50',
        },
      }}
    >
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: '0.9rem',
        }}
      >
        {item.carrier.companyName || '—'}
      </Typography>
    </Box>
  )
}

export default AddressCarrierListItem
